import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/ButtonLink';
import { OFFER_REQUEST_DETAIL_PATHS, REIMBURSEMENT_STEP_PATHS, type ReimbursementOrigin } from '../routes';
import { getPreviousStep } from '../steps';
import type { ReimbursementStepId } from '../types';

export type ReimbursementBackButtonProps = {
    currentStep: ReimbursementStepId;
    offerRequestLeadUuid: string;
    origin: ReimbursementOrigin;
    // Once the request is in, stepping back into the form would only offer to submit it twice.
    exitOnly?: boolean;
};

// Walks the wizard rather than the browser history, so leaving step one always lands on the lead the
// partner started from. Every hop replaces the current entry: the whole flow occupies the history slot
// the detail page had, so that page's own back button still points past it.
export function ReimbursementBackButton({
    currentStep,
    offerRequestLeadUuid,
    origin,
    exitOnly = false,
}: ReimbursementBackButtonProps): ReactElement {
    const { t } = useTranslation();
    const previous = exitOnly ? undefined : getPreviousStep(currentStep);
    const params = { offerRequestLeadUuid };

    return previous ? (
        <ButtonLink
            to={REIMBURSEMENT_STEP_PATHS[previous.id]}
            params={params}
            search={{ from: origin }}
            replace
            startIcon={<ChevronLeftIcon />}
            color="inherit">
            {t('OFFER_REQUESTS.DETAIL.BACK')}
        </ButtonLink>
    ) : (
        <ButtonLink
            to={OFFER_REQUEST_DETAIL_PATHS[origin]}
            params={params}
            replace
            startIcon={<ChevronLeftIcon />}
            color="inherit">
            {t('OFFER_REQUESTS.DETAIL.BACK')}
        </ButtonLink>
    );
}
